<!-- 4 = compact reportId -->
<!-- chart render -->
<ng-container *ngIf="indicatorDetail?.reportFormatId == 4 ; else other_impactItems">
  <div>
    <div>
      <p *ngIf="isIsoReport" class="content-figure uniqFigureSeq">
        {{indicatorDetail?.indicatorName}} comparison {{reportResource.lblLifeCycle}} -
        {{indicatorDetail?.functionalUnitName | lowercase}} is shown in figure #1.
      </p>
    </div>
    <div *ngIf="indicatorDetail?.isExport" class="fullReportChart">
      <piqet-angular-bar-chart
        [chartData]="componentItemsArrayForChart"
        [chartOpacity]="chartOpacity"
        [indicatorsName]="indicatorsName"
        [chartType]="generatedChartType"
        [isChartNormalized]="false"
      ></piqet-angular-bar-chart>
    </div>
    <div *ngIf="!indicatorDetail?.isExport" class="fullReportChart">
      <piqet-angular-bar-chart
        [chartData]="componentItemsArrayForChart"
        [chartOpacity]="chartOpacity"
        [indicatorsName]="indicatorsName"
        [chartType]="generatedChartType"
        [isChartNormalized]="false"
      ></piqet-angular-bar-chart>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isIsoReport">
  <br />
  <br />
</ng-container>
<ng-template #other_impactItems>
  <div *ngIf="indicatorDetail?.isExport" class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td>{{reportResource.lblLifeCycleStage}}</td>
          <td *ngFor="let item of indicatorDetail?.componentItems[0]?.componentName?.split(';')">
            {{item}}
          </td>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let p of indicatorDetail?.componentItems; let i = index">
          <td>
            <span style="padding-right: 15px">{{p.name}}</span>
          </td>
          <td *ngFor="let item of indicatorDetail?.componentItems[i]?.impactValues?.split(';')">
            <span style="color: black">{{item | decimalFormatPipe}}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="!indicatorDetail?.isExport" class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td>{{reportResource.lblLifeCycleStage}}</td>
          <td *ngFor="let item of indicatorDetail?.componentItems[0]?.componentName?.split(';')">
            {{item}}
          </td>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let p of indicatorDetail?.componentItems; let i = index">
          <td>
            <span style="padding-right: 15px">{{ p.name}}</span>
          </td>
          <td *ngFor="let item of indicatorDetail?.componentItems[i]?.impactValues.split(';')">
            <span style="color: black">{{item | decimalFormatPipe}}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="chartDesign">
    <div class="chartDesign">
      <p *ngIf="isIsoReport" class="content-figure uniqFigureSeq">
        {{indicatorDetail?.indicatorName}} comparison {{reportResource.lblLifeCycle}} -
        {{indicatorDetail?.functionalUnitName | lowercase}} is shown in figure #1.
      </p>
    </div>
    <ng-container *ngIf="isIsoReport">
      <br />
      <br />
    </ng-container>

    <!-- chart render -->
    <div *ngIf="indicatorDetail?.isExport" class="fullReportChart">
      <piqet-angular-bar-chart
        [chartData]="componentItemsArrayForChart"
        [chartOpacity]="chartOpacity"
        [indicatorsName]="indicatorsName"
        [chartType]="generatedChartType"
        [isChartNormalized]="false"
      ></piqet-angular-bar-chart>
    </div>
    <div *ngIf="!indicatorDetail?.isExport" class="fullReportChart">
      <piqet-angular-bar-chart
        [chartData]="componentItemsArrayForChart"
        [chartOpacity]="chartOpacity"
        [indicatorsName]="indicatorsName"
        [chartType]="generatedChartType"
        [isChartNormalized]="false"
      ></piqet-angular-bar-chart>
    </div>
  </div>
</ng-template>
